import {IsString} from '@pristine-ts/class-validator';
import {ErrorMessageBuilder} from '../../builders/error-message.builder';
import {advancedFormControl, FormControlTypeEnum} from '@magieno/common';
import { translationBaseKey } from '../../decorators/translation-base-key.decorator';

@translationBaseKey('calculation-title-update-options')
export class CalculationTitleUpdateOptions {
  @advancedFormControl({type: FormControlTypeEnum.Input})
  @IsString({ buildErrorMessage: ErrorMessageBuilder.build })
  title: string;
}
